import { useEffect } from "react";
import { useHttpChatAgent } from './useHttpChatAgent';
import { IIncomingRoom } from '../../../app/chatAgent/types';
import { useAppDispatch } from "../../../app/hooks";
import { IncomingChatAgentRoom } from "../../../app/chatAgent/chatAgentSlice";
import { IResponse } from '../../../hooks/useHttp';

export const useFetchAgentRoom = (userName: string) => {
    const dispatch = useAppDispatch();
    const chatRoomUrl = `/Room/${userName}`;

    const { response, error, loading, chatBaseUrl } = useHttpChatAgent({
        method: "get",
        url: chatRoomUrl,
    });
    const retrieveData = (res: IResponse | undefined) => {
        const data = res?.data;
        const chatRooms = data?.map(item => {
            return {
                roomId: item.room_id,
                sessionId: item.session_id,
                fullName: item.room_name,
                userName: item.username,
                latestMessage: item.latest_message,
                latestMessageTime: item.latest_message_time,
                unreadMessageCount: item.unread_message_count,
                status: item.status,
                roleId: item.role_id,
                participant: item.participant
            } as IIncomingRoom
        }) ?? [];
        dispatch(IncomingChatAgentRoom(chatRooms));
    }
    useEffect(() => {
        retrieveData(response);
    }, [response]);

    return { retrieveData, error, loading, chatBaseUrl, chatRoomUrl };
};
